import type { SowiftContextType, SowiftProjectStatus, SowiftRefineAction } from "@/types";

export const STATUS_LABELS: Record<SowiftProjectStatus, string> = {
  draft: "Draft",
  gathering_context: "Gathering Context",
  analyzing: "Analyzing",
  generating: "Generating",
  review: "Review",
  complete: "Complete",
};

export const STATUS_COLORS: Record<SowiftProjectStatus, string> = {
  draft: "bg-surface-tertiary/20 text-content-tertiary",
  gathering_context: "bg-blue-500/20 text-blue-400",
  analyzing: "bg-yellow-500/20 text-yellow-400",
  generating: "bg-purple-500/20 text-purple-400",
  review: "bg-orange-500/20 text-orange-400",
  complete: "bg-green-500/20 text-green-400",
};

export const CONTEXT_TYPE_LABELS: Record<SowiftContextType, string> = {
  meeting_notes: "Meeting Notes",
  slack_messages: "Slack Messages",
  project_brief: "Project Brief",
  email_thread: "Email Thread",
  requirements: "Requirements",
  other: "Other",
};

export const CONTEXT_TYPE_OPTIONS: SowiftContextType[] = [
  "meeting_notes",
  "slack_messages",
  "project_brief",
  "email_thread",
  "requirements",
  "other",
];

export const REFINE_ACTIONS: { action: SowiftRefineAction; label: string; description: string }[] = [
  { action: "expand", label: "Expand", description: "Add more detail and depth" },
  { action: "tighten", label: "Tighten", description: "Make more concise" },
  { action: "rewrite", label: "Rewrite", description: "Rewrite from scratch" },
  { action: "formalize", label: "Formalize", description: "Make more professional" },
  { action: "custom", label: "Custom", description: "Provide custom instructions" },
];

export type TabId = "overview" | "context" | "analysis" | "documents";
